import { LiveUpdateHub } from '@tc/live-updates';
import { EnvironmentService } from '@tc/foundation';
import { AuthenticationService, TokenService } from '@tc/security-oauth-legacy';
import { LoggerService } from '@tc/logger';
import { ILiveUpdateConfiguration } from '@tc/live-updates';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AccountLiveUpdateHub extends LiveUpdateHub<boolean> {
  constructor() {
    const envService = inject<EnvironmentService<ILiveUpdateConfiguration>>(EnvironmentService);
    const tokenService = inject(TokenService);
    const loggingService = inject(LoggerService);

    super(envService, loggingService, 'dropcatch', 'account', tokenService.token$.pipe(map(token => token.token)));
  }
}
